import { MediaAnalysisTarget } from '@/common/model/media/mediaAnalysisTarget'

import SimpleTable from '@/components/view/atoms/table/SimpleTable'
import TableRow from '@/components/view/atoms/table/TableRow'
import TableRowItem from '@/components/view/atoms/table/TableRowItem'
import Text, { TextColor } from '@/components/view/atoms/text/Text'

import AnalysisTargetListRow from '@/components/container/modules/media/analysisTarget/table/AnalysisTargetListRow'

interface Props {
  targets: MediaAnalysisTarget[]
  onRefresh: () => void
}

const AnalysisTargetListTable = ({ targets, onRefresh }: Props) => {
  return (
    <SimpleTable>
      <thead>
        <TableRow head>
          <TableRowItem width={320}>
            <Text size={12} color={TextColor.SECONDARY}>
              対象サイト名
            </Text>
          </TableRowItem>
          <TableRowItem>
            <Text size={12} color={TextColor.SECONDARY}>
              サイトURL
            </Text>
          </TableRowItem>
          <TableRowItem width={128}>
            <Text size={12} color={TextColor.SECONDARY}>
              競合ドメイン
            </Text>
          </TableRowItem>
          <TableRowItem width={64}>{null}</TableRowItem>
        </TableRow>
      </thead>
      <tbody>
        {targets.map((target) => (
          <AnalysisTargetListRow key={target.id} target={target} onRefresh={onRefresh} />
        ))}
      </tbody>
    </SimpleTable>
  )
}

export default AnalysisTargetListTable
